export * from './register_view.component';